<template>
  <div id="detail-quota-table">
    <soft-table
      class="table  align-items-center table-flush"
      tbody-classes="list"
      :pending="false"
      :dataTable="tableData"
    >
      <template slot="columns">
        <th>Sản phẩm</th>
        <th>Quy cách</th>
        <th>Màu</th>
        <th>Số lượng</th>
        <th>Giá</th>
      </template>
      <template slot-scope="{ row, index }">
        <td>
          <div class="product-name">
            <i class="fas fa-trash-alt" @click="handleRemoveRow(index)"></i>
            <Select2
              :required="true"
              v-model="row.productId"
              :options="products"
              :settings="{
                placeholder: 'Chọn sản phẩm'
              }"
            />
          </div>
        </td>
        <td>
          <Select2
            :required="true"
            v-model="row.productSpecifyId"
            :options="renderProductSpecify(index)"
            :settings="{
              placeholder: 'Chọn quy cách'
            }"
          />
        </td>
        <td>
          <Select2
            :required="true"
            v-model="row.color"
            :options="colors"
            :settings="{
              placeholder: 'Chọn màu'
            }"
          />
        </td>
        <td><base-input v-model="row.quantity"></base-input></td>
        <td><base-input v-model="row.price"></base-input></td>
      </template>
    </soft-table>
    <button @click="handleAddRow" class="btn btn-success btn-md">
      <i class="fas fa-plus"></i> Thêm
    </button>
  </div>
</template>

<script>
import * as productApi from "@/_services/modules/product.service";
export default {
  data() {
    return {
      tableData: [{}],
      products: [],
      myOptions: ["op1", "op2", "op3"],
      productList: [],
      colors: ["Đỏ", "Trắng", "Đen"]
    };
  },
  created() {
    this.fetchProducts();
  },
  methods: {
    handleRemoveRow(index) {
      this.tableData.splice(index, 1);
    },
    handleAddRow() {
      this.tableData.push({});
    },
    renderProductSpecify(index) {
      let productId = this.tableData[index].productId;
      if (productId) {
        let product = this.productList.find(e => e.id == productId);
        let tmp = product.productSpecifys.map(e => ({
          id: e.id,
          text: e.name
        }));
        return tmp;
      }
      return [];
    },
    async fetchProducts() {
      const res = await productApi.findAll();
      this.productList = res.data.data;
      this.products = res.data.data.map(e => ({
        id: e.id,
        text: `${e.name}(${e.code})`
      }));
      console.log("product", this.products);
    }
  }
};
</script>

<style scoped lang="scss">
#detail-quota-table {
  .product-name {
    display: flex;
    justify-content: center;
    align-items: center;
    i {
      font-size: 15px;
      color: red;
      margin-right: 5px;
      display: none;
    }
  }
  tr:hover {
    .product-name {
      i {
        display: block;
      }
    }
  }
  .form-group {
    margin-bottom: 0 !important;
  }
}
</style>
